<template>
  <div class="card text-b14">
    <div :class="cardClasses" :style="lineClampStyle">
      <div v-html="formatDescription"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatText } from '@/utils';
import { ref, computed, type CSSProperties, toRefs } from 'vue';

const props = withDefaults(
  defineProps<{
    text: string;
    textLength?: number;
    lineNumber?: number;
  }>(),
  {
    textLength: 130,
    initialShowMore: false,
    lineNumber: 4,
  }
);
const { lineNumber, text, textLength } = toRefs(props);
const showMore = ref<boolean>(false);

const summerizeDescription = computed(() => text.value.length > textLength.value);
const formatDescription = formatText(text.value);
const cardClasses = computed(() => ['card-description leaning-24', summerizeDescription.value && !showMore.value ? 'text-overflow' : '']);

const lineClampStyle = computed<CSSProperties>(() => ({
  display: showMore.value ? 'block' : '-webkit-box',
  '-webkit-line-clamp': lineNumber.value,
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
}));
</script>

<style lang="scss" scoped>
@import url('./index.scss');
</style>
